import {useState, useEffect} from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export const useUser = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser ?? null);
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    return { user, loading };
}
